import { gql } from "@apollo/client";

export const loginQuery = gql`
  query Login($password: String!, $email: String!) {
    login(password: $password, email: $email) {
      user {
        id
        email
        disabled
        name
        permissions
      }
      authToken
    }
  }
`;
